<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<!-- 个人中心导航 -->
				<Usernavleft></Usernavleft>
				<div class="ttshop_useright">
					<!-- 我的收藏 -->
					<div class="ttshop_coupon min_h">
						<!-- 暂无收藏商品时显示 -->
						<div class="ttshop_zwsc">
							<img src="../../assets/images/ttshop_sc.png" alt="">
							<p>暂无收藏商品</p>
						</div>
						<!-- 收藏商品列表 -->
						<div class="ttshop_collection clearfloat">
							<div class="ttshop_collectionlist" v-for="(item,index) in 8" :key="item">
								<div class="ttshop_collectionimg">
									<img src="../../assets/images/goods_1.png" alt="" class="ttshop_collecimg">
									<div class="ttshop_gmqx clearfloat">
										<button class="ttshop_join">
											<i><img src="../../assets/images/ttshop_addshop.png" alt=""></i>
											加入购物车
										</button>
										<button class="ttshop_removeshop">取消收藏</button>
									</div>
								</div>
								<div  :class="['ttshop_collcon','ttshop_collcon'+index]">
									<div class="ttshop_collconter swiper-container swiper-no-swiping" >
										<ul class="clearfloat swiper-wrapper">
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img src="../../assets/images/goods_1.png" alt="" ></li>
										</ul>
									</div>
									<!-- 左右箭头 -->
									<div class="swiper-button-prev ttshop_prev"></div>
									<div class="swiper-button-next ttshop_next"></div>
								</div>
								<div class="ttshop_collbut">
									<h5>￥98.00</h5>
									<p class="ttshop_shopname">七匹狼T恤男士翻领纯棉短袖2020夏季新款条纹POLO衫男上衣男夏秋季连帽宽松</p>
									<div class="ttshop_colltext clearfloat">
										<div class="ttshop_colltextleft">
											<p><span>50</span>评价</p>
										</div>
										<div class="ttshop_colltextright">
											<p><span>100%</span>好评</p>
										</div>
									</div>
									<div class="clearfloat ttshop_collbutton">
										<p>满300减30</p>
										<p>免邮</p>
									</div>
								</div>
							</div>
						</div>
						<div class="ttshop_myorderpage clearfloat">
							<el-pagination class="ttshop_pages" background layout="prev, pager, next" :total="40"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Usernavleft from "./components/user_navleft";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Header,
			Userheader,
			Usernavleft,
			Foot,
		},
		data() {
			return {

			}
		},
		mounted() {
			// 商品轮播
			for(let i = 0;i<8;i++){
				let element = ".ttshop_collcon"+ i +" .ttshop_collconter";
				let nextEl = ".ttshop_collcon"+ i +" .ttshop_next";
				let prevEl = ".ttshop_collcon"+ i +" .ttshop_prev";
				let mySwiper = new Swiper(element, {
					loop: false, // 循环模式选项
					slidesPerView: 5,
					spaceBetween: 3,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					}
				});
			}
		},
		methods: {

		}
	};
</script>

<style lang="scss" scoped>
	.ttshop_coupon {
		width: 100%;
		background: #fff;
		padding: 20px 0 40px 0px;
		box-sizing: border-box;

		.ttshop_zwsc {
			width: 100%;
			padding-top: 200px;
			box-sizing: border-box;
			display: none;

			img {
				display: block;
				width: 85px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}

		.ttshop_collection {
			width: 100%;
			.ttshop_collectionlist {
				float: left;
				width: 246px;
				background: #fff;
				padding: 12px;
				box-sizing: border-box;
				margin-right: 2px;
				margin-bottom: 20px;

				&:nth-child(4n) {
					margin-right: 0;
				}

				.ttshop_collectionimg {
					width: 100%;
					height: 222px;
					margin-bottom: 8px;
					position: relative;
					overflow: hidden;

					.ttshop_collecimg {
						display: block;
						width: 100%;
						height: 100%;
						object-fit: cover;
						margin: 0 auto;
					}

					.ttshop_gmqx {
						width: 100%;
						height: 28px;
						background: #FF0E25;
						position: absolute;
						bottom: 0;
						left: -100%;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;

						.ttshop_join {
							float: left;
							width: 148px;
							height: 28px;
							border: 0;
							outline: none;
							font-size: 12px;
							color: #fff;
							background: #FF0E25;
							cursor: pointer;

							i {
								display: inline-block;
								width: 16px;
								height: 16px;
								vertical-align: -3px;

								img {
									display: block;
									width: 100%;
								}
							}
						}

						.ttshop_removeshop {
							width: 73px;
							height: 26px;
							margin-top: 1px;
							margin-right: 1px;
							font-size: 12px;
							color: #FF0E25;
							border: 0;
							outline: none;
							cursor: pointer;
							background: #fff;
						}
					}

					&:hover .ttshop_gmqx {
						left: 0;
					}
				}

				.ttshop_collcon {
					width: 100%;
					padding: 0 19px;
					box-sizing: border-box;
					position: relative;
					margin-bottom: 12px;

					.ttshop_collconter {
						width: 100%;
						padding: 0 1px;
						box-sizing: border-box;
						ul {
							li {
								float: left;
								width: 32px;
								height: 32px;
								border: 1px solid #EBEBEB;
								padding: 1px; 
								box-sizing: border-box;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;

								&:hover {
									border-color: #FF0E25;
								}

								img {
									display: block;
									width: 28px;
									height: 28px;
									margin: 0 auto;
									object-fit: cover;
								}
								&:last-child{margin-right: 0 !important;}
							}
						}
					}

					.ttshop_prev {
						width: 14px;
						height: 14px;
						margin-top: -7px;
						background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
						left: 0;
						cursor: pointer;
						z-index: 100;
						outline: none;
					}

					.ttshop_next {
						width: 14px;
						height: 14px;
						margin-top: -7px;
						background: url(../../assets/images/ttshop_scright.png) center no-repeat;
						right: 0;
						cursor: pointer;
						z-index: 100;
						outline: none;
					}
				}

				.ttshop_collbut {
					width: 100%;

					h5 {
						font-size: 20px;
						color: #FF4300;
						font-weight: bold;
						line-height: 20px;
						margin-bottom: 7px;
					}

					.ttshop_shopname {
						width: 100%;
						font-size: 12px;
						color: #666;
						font-weight: 400;
						line-height: 18px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						max-height: 36px;
						height: 36px;
						margin-bottom: 8px;
					}

					.ttshop_colltext {
						width: 100%;
						margin-bottom: 12px;

						.ttshop_colltextleft {
							float: left;

							p {
								font-size: 12px;
								color: #999;
								line-height: 12px;

								span {
									font-size: 12px;
									color: #0E9CFF;
									margin-right: 4px;
								}
							}
						}

						.ttshop_colltextright {
							float: right;

							p {
								font-size: 12px;
								color: #999;
								line-height: 12px;

								span {
									font-size: 12px;
									color: #FF9010;
								}
							}
						}
					}

					.ttshop_collbutton {
						width: 100%;

						p {
							float: left;
							font-size: 12px;
							color: #FF0E25;
							border: 1px solid #FF0E25;
							border-radius: 3px;
							font-weight: 400;
							line-height: 12px;
							padding: 2px 4px;
							box-sizing: border-box;
							margin-right: 4px;
						}
					}
				}
			}
		}
		.ttshop_myorderpage{
			width: 100%;
			margin-top: 32px;
			.ttshop_pages{
				float: right;
			}
		}
	}
</style>
